import { render } from "./DashboardLayout.vue?vue&type=template&id=b40a2690"
import script from "./DashboardLayout.vue?vue&type=script&lang=js"
export * from "./DashboardLayout.vue?vue&type=script&lang=js"

import "./DashboardLayout.vue?vue&type=style&index=0&id=b40a2690&lang=css"
script.render = render

export default script